<template>
  <files
    :files='files'
    :title='title'
    :is_uploading='is_uploading'
    @add='addFile'
    :disabled='disabled'
    :show_description="true"
  />
</template>

<script>
import Files from './Files';
import filesAPI from '@/api/files';
import { WORK_ORDER } from '@/api/files';

export default {
  name: 'work-order-files',
  props: {
    files: {
      required: true
    },
    work_order_id: {
      required: true
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    title: {
      required: false,
      type: String,
      default: 'Work Order Files'
    }
  },
  data: () => ({
    file_to_be_uploaded: null,
    is_uploading: false
  }),
  methods: {
    async addFile(file_type, file_to_be_uploaded, description){
        this.is_uploading = true;
        const response = await filesAPI.getPresignedURL(file_to_be_uploaded.name, WORK_ORDER, this.work_order_id, file_type, description);
        await filesAPI.uploadToAWS(response.url, file_to_be_uploaded);
        this.is_uploading = false;
        this.files.push(response.file);
    }
  },
  components: {
    'files': Files
  }
}
</script>
